<!--Mobile Nav-->
<fgb-page-header [pageTitle]="'claimed.page.title'" [showBalance]="false"></fgb-page-header>

<div class="container wallet-background">
  <ng-container *ifScreenSize="screenSize.Desktop">
    <div class="d-flex align-items-center py-4">
      <!-- Back Button -->
      <div class="text-white back-button" [routerLink]="'/rewards/wallet'">
        <span class="icon material-icons cursor-pointer">arrow_back_ios</span>
      </div>
      <!-- Title -->
      <h5 class="m-0 text-white wallet-redeemed-title text-capitalize">{{ 'wallet.redeemed.title' | translate }}</h5>
      <div class="back-button"></div>
    </div>
  </ng-container>
  <ng-container
    *ngIf="
      {
        walletItemsClaimed: walletItemsClaimed$ | async,
      } as walletItems;
      else noWalletItems
    "
  >
    <ng-container *ngIf="walletItems.walletItemsClaimed && walletItems.walletItemsClaimed.length; else noWalletItems">
      <fgbcl-rewards-wallet-redeemed-list
        [pageSize]="0"
        [redeemedItems]="walletItems.walletItemsClaimed"
      ></fgbcl-rewards-wallet-redeemed-list>
    </ng-container>
  </ng-container>
</div>

<ng-template #noWalletItems>
  <div class="">
    <div class="border border-grey bg-secondary rounded">
      <div class="fw-bold font-size-12 text-center text-white py-3">
        {{ 'claimed.rewards.placeholder.description' | translate }}
      </div>
    </div>
  </div>
</ng-template>
